import { CheckIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Actions as ADVISORACTIONS } from "../../store/actions/advisorActions";
import { Actions as PAYMENTACTIONS } from "../../store/actions/paymentActions";

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

const AdvisorBundleCard = ({ bundle, currency, advisorId, updateSetting, updateAdvisorDetails, selectBundle, forModal }) => {
	const save = () => {
		selectBundle();
		// updateCompanyDetails({
		// 	org: String(org),
		// 	plan: bundle.id,
		// });
	};

	const features = bundle?.offerFeatures ?? bundle?.features

	return (
		<div
			key={bundle.id}
			className={classNames(
				bundle.current ? "bg-white ring-2 ring-orange-700 shadow-md" : "bg-orange-700",

				"pt-6 px-6 pb-3 rounded-lg lg:px-8 lg:pt-12",
			)}
		>
			<div>
				<h3 className={classNames(bundle.current ? "text-orange-600" : "text-white", "font-semibold")}>
					{bundle.name}
				</h3>
				<div className="flex flex-col items-start sm:flex-row sm:items-center sm:justify-between lg:flex-col lg:items-start">
					{
						bundle.price == 0 ?
						<div className="mt-3 flex items-center">
							<span className="text-sm mr-2">
								Starts from
							</span>
							<p
								className={classNames(
									bundle.current ? "text-orange-600" : "text-white",
									"text-4xl font-bold tracking-tight",
								)}
							>
								{currency}
								1
							</p>
							<div className="ml-4">
								<p className={classNames(bundle.current ? "text-gray-700" : "text-white", "text-md")}>
									/ Employee / Month
								</p>
								{/*
							  <p className={classNames(bundle.current ? 'text-gray-500' : 'text-orange-200', 'text-md')}>
								Billed yearly ({currencySign}{bundle.priceYearly})
							  </p>
							*/}
							</div>
						</div>
							:
						<div className="mt-3 flex items-center">
							<p
								className={classNames(
									bundle.current ? "text-orange-600" : "text-white",
									"text-4xl font-bold tracking-tight",
								)}
							>
								{currency}
								{bundle.price}
							</p>
							<div className="ml-4">
								<p className={classNames(bundle.current ? "text-gray-700" : "text-white", "text-md")}>
									/ {bundle.licenseDurationMonths == 1 ? "Month" : "Year"}
								</p>
								{/*
							  <p className={classNames(bundle.current ? 'text-gray-500' : 'text-orange-200', 'text-md')}>
								Billed yearly ({currencySign}{bundle.priceYearly})
							  </p>
							*/}
							</div>
						</div>
					}
					<p className={classNames(bundle.current ? "text-gray-700" : "text-white", "text-md")}>
						{bundle.description}
					</p>
					<a
						href="#"
						className={classNames(
							bundle.current ? "bg-orange-600 text-white" : "bg-white text-orange-600 hover:bg-orange-50",
							"mt-6 w-full inline-block py-2 px-8 border border-transparent rounded-md shadow-sm text-center text-md font-medium sm:mt-0 sm:w-auto lg:mt-6 lg:w-full",
						)}
						onClick={() => {
							// if (bundle.current) return;
							save();
						}}
					>
						{bundle.current ? "Current" : `${forModal ? "Select" : "Switch to"} ${bundle.name}`}
					</a>
				</div>
			</div>
			<h4 className="sr-only">Features</h4>
			<ul
				role="list"
				className={classNames(
					bundle.current
						? "border-gray-200 divide-gray-200"
						: "border-orange-500 divide-orange-500 divide-opacity-75",
					"mt-7 border-t divide-y lg:border-t-0",
				)}
			>
				{features?.map((mainFeature, index) => (
					<li
						key={`${bundle.id}_feature_${index}`}
						className="flex items-center py-3"
					>
						<CheckIcon
							className={classNames(
								bundle.current ? "text-orange-500" : "text-orange-200",
								"w-5 h-5 flex-shrink-0",
							)}
							aria-hidden="true"
						/>
						<span
							className={classNames(
								bundle.current ? "text-gray-600" : "text-white",
								"ml-3 text-md font-medium",
							)}
						>
							{mainFeature}
						</span>
					</li>
				))}
			</ul>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const jurisdictions = {
		new: state.company?.newCompany?.jurisdiction,
		current: state.company?.settings?.jurisdiction,
	};

	const currency = state.jurisdictions?.find(
		(j) => j.countryCode === jurisdictions[ownProps.forModal ? "new" : "current"],
	)?.currency;

	return {
		currency,
		advisorId: state.my.profile.advisorId,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {

  const bundle = ownProps.bundle

  return ({
    selectBundle: () => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
    // updateCompanyDetails: (body) => dispatch(COMPANYACTIONS.updateCompanyDetails(body, true, ownProps.forModal)),
	updateAdvisorDetails: (details) => dispatch(ADVISORACTIONS.updateAdvisorDetails(details)),
  })
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdvisorBundleCard) 
